import post from './methodPost';
import del from './methodDelete';

export default {
  ...post,
  ...del
};
